import { motion } from 'motion/react'
import { prefersReducedMotion } from '$javascript/utils/utils'

export default function Testimonials({ testimonials }) {
    return (
        <div className="mx-auto grid grid-cols-[repeat(auto-fit,minmax(min(100%,400px),1fr))] max-w-[1200px] gap-8">
            {testimonials.map((testimonial, index) => (
                <motion.div
                    key={index}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={
                        prefersReducedMotion()
                            ? { hidden: { opacity: 0 }, visible: { opacity: 1 } }
                            : {
                                hidden: { opacity: 0, scale: 0.95 },
                                visible: {
                                    opacity: 1,
                                    scale: 1,
                                    transition: { duration: 0.6, delay: index * 0.1 }
                                }
                            }
                    }
                    className="testimonial-card bg-neutral-50 shadow-lg p-8 rounded-xl"
                >
                    <blockquote>
                        <p
                            className="prose italic mb-4"
                        >
                            "{testimonial.quote}"
                        </p>
                        <footer
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 'var(--space-md)'
                            }}
                        >
                            <img
                                src={testimonial.avatar}
                                alt={testimonial.author}
                                className="size-14 rounded-full object-cover"
                            />
                            <div>
                                <div
                                    style={{
                                        fontWeight: '600',
                                        color: 'var(--color-neutral-900)',
                                        marginBottom: '4px'
                                    }}
                                >
                                    {testimonial.author}
                                </div>
                                <div
                                    style={{
                                        fontSize: 'var(--text-sm)',
                                        color: 'var(--color-neutral-600)'
                                    }}
                                >
                                    {testimonial.role}
                                </div>
                            </div>
                        </footer>
                    </blockquote>
                </motion.div>
            ))}
        </div>
    )
};